import { Customer } from '@/components/Invoice/types';

export const getCustomerDisplayName = (customerSnapshot?: Customer) => {
  const { nickname, name } = customerSnapshot || {};
  if (nickname) return nickname;
  if (name) return name;
  return undefined;
};
